(function($){

  if(!$.gnv){
    $.gnv = new Object();
  };

  $.gnv.accessibleDropdown = function (){

    //display the dropdown list pressing the spacebar
    $('.has-dropdown a').keypress(function(e) {
      $('.c-nav .dropdown').toggle();

      //disable scroll page pressing the spacebar
      if (e.keyCode == 32) {
        e.preventDefault();
      } 
    });
    
    //if the element next dropdown button is focus, hide the dropdown list
    $('.has-dropdown').next().children().focus(function(e) {

      //hide dropdown list 
      $('.c-nav .dropdown').css('display','none')
    })
  };


  $.gnv.accessibleDropdown();


})(jQuery);
